@if (expandHamburgerMenu) {
  <div class="cfa-hamburger-menu-backdrop d-lg-none" [@menuBackdropState]="'active'"></div>
}
<div #hamburgerMenu class="container pt-4 pb-4 cfa-hamburger-menu d-lg-none"
  [class.mat-app-background]="useMaterialTheme" [class.cfaCustomLightTheme]="!useMaterialTheme"
  [@menuState]="expandHamburgerMenu? 'active' : 'inactive'">
  <div class="row mb-3" (click)="clickHome()" id="hamburgerHome">
    <div class="col cfa-18 clicky">
      HOME
    </div>
  </div>
  @for (tab of cfaTabs; track tab; let i = $index) {
    <div class="row mb-3" (click)="selectTab($event, tab, true)" id="tab{{i}}" [class.disabled]="tab.disabled">
      <div class="col-auto cfa-menu-tab-label align-self-center cfa-18 clicky pr-0"
        [class.activeTab]="tab.active">
        {{tab.label}}
      </div>
      <div class="col-auto cfa-15 align-self-center text-center pl-0 pr-0">
        @if (tab.childTabs && tab.childTabs.length > 0) {
          <svg-icon class="cfa-tab-icon"
          src="https://d4gii57lvoht3.cloudfront.net/images/Arrow_Down.svg"></svg-icon>
        }
      </div>
    </div>
    @if (tab.childTabs && tab.childTabs.length > 0 && tab.expanded) {
      <div class="childTabList"
        [@openChildTabState]="'active'">
        @for (cTab of tab.childTabs; track cTab; let j = $index) {
          <div class="row cfa-child-nav-tab mb-3 w-100 m-0"
            [class.active]="cTab.active" [class.disabled]="tab.disabled || cTab.disabled"
            (click)="selectTab($event, cTab)" id="cTab{{j}}">
            <div class="col-12 align-self-center cfa-15 text-left">
              {{cTab.label}}
            </div>
          </div>
        }
      </div>
    }
  }
  @if (cfaTabs.length > 0) {
    <hr class="mb-4 mt-4">
  }
  @for (menuItem of cfaMenuItems; track menuItem; let i = $index) {
    <div class="row mb-3" (click)="selectMenuItem(menuItem)"
      id="menuItem{{i}}" [class.disabled]="menuItem.disabled">
      <div class="col" [class.cfa-14]="menuItem.textOnly" [class.cfa-18]="!menuItem.textOnly"
        [class.clicky]="!menuItem.textOnly">
        {{menuItem.label}}
      </div>
    </div>
  }
  @if (cfaMenuItems.length > 0) {
    <hr class="mb-4 mt-4">
  }
  @if (userName) {
    <div class="row mb-3">
      <div class="col cfa-14">
        {{userName}}
      </div>
    </div>
  }
  @if (userName) {
    <div class="row">
      <div class="col cfa-18 activeTab clicky" (click)="clickSignOut()" id="signOut-button">
        Sign Out
      </div>
    </div>
  }
</div>
